import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Input
} from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { resetAdvancedSearchParams, setAdvancedSearchParams } from "../../redux/actions/actions"

export default function AdvancedSearchModal({ parameters, title, isOpen, onClose, color, hoverColor }) {
    const [advancedSearch, setAdvancedSearch] = useState([])
    const dispatch = useDispatch()

    const createAdvancedSearchState = () => {
        console.log(parameters)
        setAdvancedSearch(parameters.map(parameter => [parameter, '']))
    }

    const changeHandler = (e) => {
        let newParams = advancedSearch.map(param => param)
        console.log(e.target.id)
        let currentId = Number(e.target.id.substring(e.target.id.indexOf('_') + 1))
        if ((newParams[currentId][0].indexOf('Number') !== -1 || newParams[currentId][0].indexOf('Duration') !== -1) && e.target.value !== '') {
            if (Number(e.target.value)) {
                newParams[currentId][1] = e.target.value
            }
        }
        else {
            newParams[currentId][1] = e.target.value
        }
        setAdvancedSearch(newParams)
    }

    const clickHandler = () => {
        dispatch(setAdvancedSearchParams(advancedSearch))
        let newParams = advancedSearch.map(param => [param[0], ""])
        setAdvancedSearch(newParams)
        onClose()
    }

    const cancelHandler = () => {
        let newParams = advancedSearch.map(param => [param[0], ""])
        setAdvancedSearch(newParams)
        dispatch(resetAdvancedSearchParams())
        onClose()
    }

    useEffect(() => {
        createAdvancedSearchState()
        // eslint-disable-next-line
    }, [parameters])

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader color={color}>{title}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {
                        parameters.map((parameter, idx) =>
                            <FormControl key={idx}>
                                <FormLabel
                                    variant="custom"
                                    htmlFor={`parameter_${idx}`}
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    {parameter}
                                </FormLabel>
                                <Input
                                    id={`parameter_${idx}`}
                                    width={["100%", "100%", "90%", "85%"]}
                                    bgColor="white"
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    borderRadius="13px"
                                    height='40px'
                                    value={advancedSearch[idx] ? advancedSearch[idx][1] : ''}
                                    onChange={changeHandler}
                                />
                            </FormControl>
                        )
                    }
                </ModalBody>

                <ModalFooter>
                    <Button colorScheme='gray' mr={3} onClick={cancelHandler}>
                        Cancel
                    </Button>
                    <Button
                        bg={color}
                        _hover={{ bg: hoverColor }}
                        color='#ffffff'
                        onClick={clickHandler}
                    >
                        Search
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}